import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { usePostHog } from "posthog-js/react";
import { Dropdown, Grid, Icon, InputText, Text } from "~/components-shared";
import { useDispatch, useSelector } from "react-redux";
import { AuthoritiesEnum } from "~/types/enums";
import styled, { useTheme } from "styled-components";
import useAbacExt from "~/hooks/abac";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import { TopicActionEnum } from "~/store/topics/types";
import topicFootprintActionCreators from "~/store/topicFootprints/actions";
const StyledDropdown = styled(Dropdown)`
  display: inline-block;
`;
const LabelColor = styled.i`
  background-color: ${_ref => {
  let {
    $color
  } = _ref;
  return $color;
}};
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin: 0.2rem 1rem 0 0;
  display: block;
`;
const StyledListItem = styled(Dropdown.ListItem)`
  position: sticky;
  bottom: 0;
  background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.background.primary;
}};

  &:hover {
    background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.background.primary;
}};
    span,
    i {
      color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.text.primary;
}};
    }
  }
`;
const TopicFootprintLabels = _ref5 => {
  let {
    topicId,
    footprint
  } = _ref5;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const posthog = usePostHog();
  const labels = useSelector(topicSelectors.getLabels);
  const [searchValue, setSearchValue] = useState("");
  const filteredLabels = labels.filter(label => `${label.title}.${label.description}`.toLowerCase().includes(searchValue.toLowerCase()) && (!label.topic || label.topic.id === topicId));
  const handleAddLabel = labelId => {
    dispatch(topicFootprintActionCreators.addLabelStarted(topicId, footprint.id, labelId));
    posthog.capture(`Topic Footprint – Add Label`, {
      topicId,
      footprintId: footprint.id,
      labelId
    });
  };
  const handleRemoveLabel = labelId => {
    dispatch(topicFootprintActionCreators.removeLabelStarted(topicId, footprint.id, labelId));
    posthog.capture(`Topic Footprint – Remove Label`, {
      topicId,
      footprintId: footprint.id,
      labelId
    });
  };
  const handleManageLabels = () => {
    dispatch(topicActionCreators.actionChanged(TopicActionEnum.MANAGE_LABELS, topicId));
    posthog.capture(`Topic Footprint – Manage Labels`, {
      topicId
    });
  };
  const handleSearch = query => {
    setSearchValue(query);
  };
  return /*#__PURE__*/React.createElement(StyledDropdown, {
    direction: "bottomRight",
    handlerProps: {
      color: "transparent",
      fontSize: 2.8,
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("TopicFootprintLabels.labels"),
      s: {
        p: 2,
        mt: 2
      },
      display: "inline-block"
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      src: "sell",
      display: "block",
      color: "inherit"
    }),
    maxWidth: "260px"
  }, _ref6 => {
    let {
      isOpen,
      onItemClick
    } = _ref6;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      noHover: true,
      sticky: true
    }, /*#__PURE__*/React.createElement(InputText, {
      autoFocus: true,
      value: searchValue,
      onChange: handleSearch,
      elemBefore: /*#__PURE__*/React.createElement(Icon, {
        src: "search",
        s: {
          mr: 2
        }
      }),
      placeholder: t("common.actions.search"),
      clearButton: true
    })), filteredLabels.map(label => /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        if (footprint.labels.find(_ref7 => {
          let {
            id
          } = _ref7;
          return id === label.id;
        })) {
          handleRemoveLabel(label.id);
        } else {
          handleAddLabel(label.id);
        }
        handleSearch("");
        onItemClick();
      },
      key: label.id,
      selected: !!footprint.labels.find(_ref8 => {
        let {
          id
        } = _ref8;
        return id === label.id;
      }),
      textWrap: true
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      gap: 2,
      template: "1rem auto"
    }, /*#__PURE__*/React.createElement(LabelColor, {
      $color: label.color
    }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      fontSize: 3
    }, label.title), label.description && /*#__PURE__*/React.createElement(Text, {
      fontSize: 3,
      color: "textSecondary",
      s: {
        mt: 1
      },
      display: "block"
    }, label.description))))), userHas(AuthoritiesEnum.TOPICS_WRITE) && /*#__PURE__*/React.createElement(StyledListItem, {
      onClick: () => {
        onItemClick();
        handleManageLabels();
      },
      textWrap: true
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      gap: 2,
      template: "1rem auto",
      align: "center"
    }, /*#__PURE__*/React.createElement(Icon, {
      color: colors.text.secondary,
      src: "cog",
      scale: 3
    }), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      fontSize: 3
    }, t("TopicFootprintLabels.manageLabels")))));
  });
};
export default TopicFootprintLabels;